import { render } from "./Index.vue?vue&type=template&id=0cfa6086&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0cfa6086&lang=scss&scoped=true"

import exportComponent from "/Users/flian/Documents/inncom/2307.drx5.web.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfa6086"]])

export default __exports__